export function SettingsIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M2.3125 3.2C1.86309 3.2 1.5 3.5575 1.5 4C1.5 4.4425 1.86309 4.8 2.3125 4.8H4.51387C4.82617 5.5075 5.54219 6 6.375 6C7.20781 6 7.92383 5.5075 8.23613 4.8H13.6875C14.1369 4.8 14.5 4.4425 14.5 4C14.5 3.5575 14.1369 3.2 13.6875 3.2H8.23613C7.92383 2.4925 7.20781 2 6.375 2C5.54219 2 4.82617 2.4925 4.51387 3.2H2.3125ZM2.3125 7.2C1.86309 7.2 1.5 7.5575 1.5 8C1.5 8.4425 1.86309 8.8 2.3125 8.8H8.57637C8.88867 9.5075 9.60469 10 10.4375 10C11.2703 10 11.9863 9.5075 12.2986 8.8H13.6875C14.1369 8.8 14.5 8.4425 14.5 8C14.5 7.5575 14.1369 7.2 13.6875 7.2H12.2986C11.9863 6.4925 11.2703 6 10.4375 6C9.60469 6 8.88867 6.4925 8.57637 7.2H2.3125ZM2.3125 11.2C1.86309 11.2 1.5 11.5575 1.5 12C1.5 12.4425 1.86309 12.8 2.3125 12.8H3.70137C4.01367 13.5075 4.72969 14 5.5625 14C6.39531 14 7.11133 13.5075 7.42363 12.8H13.6875C14.1369 12.8 14.5 12.4425 14.5 12C14.5 11.5575 14.1369 11.2 13.6875 11.2H7.42363C7.11133 10.4925 6.39531 10 5.5625 10C4.72969 10 4.01367 10.4925 3.70137 11.2H2.3125Z"
        fill="currentColor"
      />
    </svg>
  );
}
